import { ApiAxios } from "../Configs/Api";

const USeUpdateData = (url, params, header) => {
    const config = {
        headers: {
            ...header
        }
    }
    return ApiAxios.put(url, params, config);
}
export default USeUpdateData